module.exports = __webpack_public_path__ + "img/fico-world.69b548e7.jpg";